import React from "react"
import downloadicon from "../images/downloadicon.png"
import resume from "../documents/WebDeveloperResume.pdf"

export default function Summary() {
    return (
        <div className="summary">
            <h2>Hello! I'm CJ Stewart</h2>
            <p>I'm a Greensboro, NC based Front-End Software Engineer with a specialty in React. I'm currently working at Channel One Regional Food Bank as their remote Web Developer. I also freelance IT and for other special projects on the side, like repairing video game consoles and accessories, pinball machines, and arcade cabinets!</p>
            <p>In my free time, I enjoy practicing piano and guitar, playing video games, or exploring the beautiful countryside of North Carolina</p>
            <div>
                <a href={resume} target="_blank">Resume <img src={downloadicon}/></a>
            </div>
        </div>
    )
}